import { smoothScroll } from '../utils/smooth-scroll';

const OFFSET_SCROLL = 240;

const inpageLinks = document.querySelectorAll('main a[href^="#"]');

// add some offset, so the element is visible when scrolled to
const addClickEvent = (link, offset = OFFSET_SCROLL) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const { target } = event;
    const linkedContentTop = document.body
      .querySelector(`${target.hash}`)
      ?.getBoundingClientRect().top;
    const scrollTo = Math.round(linkedContentTop) + window.scrollY;
    // '0' is falsy, so it needs to be included as good to proceed
    if (scrollTo >= 0) {
      smoothScroll(scrollTo - offset);
    }
  });
};

(() => {
  if (inpageLinks.length) {
    inpageLinks.forEach((link) => addClickEvent(link));
  }
})();
